/* istanbul ignore file */

import { getColor } from "@chakra-ui/theme-tools";
import { solidButtonShades } from "../utils";

const variants = {
  outline: ({ colorScheme, colorMode }) => {
    if (colorScheme === "gray") {
      return {
        borderColor: colorMode === "dark" ? "rgba(255, 255, 255, 0.18)" : "rgba(27, 34, 40, 0.18)",
        _hover: {
          backgroundColor:
            colorMode === "dark" ? "rgba(255, 255, 255, 0.08)" : "rgba(27, 34, 40, 0.08)",
        },
        _active: {
          backgroundColor:
            colorMode === "dark" ? "rgba(255, 255, 255, 0.18)" : "rgba(27, 34, 40, 0.18)",
        },
      };
    }

    return {}; // return empty object for other color schemes
  },
  solid: ({ colorScheme, theme }) => {
    if (colorScheme !== "integrator") {
      return {}; // leave other color schemes on Chakra's default
    }

    const rest = getColor(theme, "integrator.500");
    const { color, hover, active } = solidButtonShades(rest, theme);

    return {
      bg: rest,
      color,
      // Pin disabled buttons to the resting bg instead of Chakra's pale `.200`.
      _hover: { bg: hover, _disabled: { bg: rest } },
      _active: { bg: active, _disabled: { bg: rest } },
    };
  },
};

const button = {
  variants,
};

export default button;
